export const TabTitle = (title) => {
    return (document.title = "AKLS-Delights || " + title)
}